import React, { useLayoutEffect, useRef } from "react";
import { useState, useEffect } from "react";
import { useGlobalState } from "../Context/GlobalStateContext";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import axiosAuth from "../Axios/Interceptors";
import AppContext from "../Context/Context";
import LockUnlock from "../App/LockUnlock";
import ConfirmationModal from "../App/ConfirmationModal";
import ColumnFilterCheckboxList from "../App/ColumnFilterCheckboxList";
import {
  DownloadClientsDataInExcel,
  GetRefindURLPage,
  GetThumbnailImage,
  SortTheList,
} from "../Shared/Utility";
import ContentLibrary from "./ContentLibrary";
import LockUnlockV2 from "../App/LockUnlockV2";
import moment from "moment";
import QuillEditor from "../QuillEditor";
import ProductFaqs from "./ProductFaqs";

function Product() {
  const globalState = useGlobalState();
  const [showAnimation, setShowAnimation] = useState(false);
  const [objectAdminData, setObjectAdminData] = useState<any>([]);
  const [productListsData, setProductListsData] = useState<any>([]);
  const [editMode, setEditMode] = useState(0);
  const [showOrders, setShowOrders] = useState(false);
  const [locked, setLocked] = useState(true);

  const [showOrdersImages, setShowOrdersImages] = useState(false);
  const [lockedImages, setLockedImages] = useState(true);

  const [showOrdersRelatedProducts, setShowOrdersRelatedProducts] =
    useState(false);
  const [lockedRelatedProducts, setLockedRelatedProducts] = useState(true);
  const [relatedProductsData, setRelatedProductsData] = useState<any>([]);
  const [selectedRelatedProductID, setSelectedRelatedProductID] = useState(0);

  const [selectedStatus, setSelectedStatus] = useState(1);
  const [type, setType] = useState(30);
  const [showAddNewModal, setShowAddNewModal] = useState(false);
  const [selectedProductType, setSelectedProductType] = useState(0);
  const [selectedParentID, setSelectedParentID] = useState(0);
  const [productTab, setProductTab] = useState(1);

  const [showContentLibraryModal, setShowContentLibraryModal] = useState(false);
  const [imagesData, setImagesData] = useState<any>([]);
  const [informationTab, setInformationTab] = useState(1);
  const [addEditObject, setAddEditObject] = useState({
    PTProductID: 0,
    PTProductCategoryID: 0,
    PTProductStatusID: 0,
    PTProductAvailabilityID: 0,
    PTProductTaxClassID: 0,
    PTProductTaxStatusID: 0,
    Name: "",
    Description: "",
    ShortDescription: "",
    URLFriendlyName: "",
    MainImageURL: "",
    ThumbnailURL: "",
    BackgroundImage: "",
    MetaKeywords: "",
    MetaTitle: "",
    MetaDescription: "",
    PTOrderBy: 0,
    VisibilityStatus: 0,
    Binder: "",
    Filter: "",
    ParentID: 0,
    Strength: 0,
    Wrapper: "",
    PurchaseNote: "",
    SKU: "",
    ExternalID: 0,
    IsFree: 0,
    IsActive: 0,
    OrderLimit: 0,
    Envelope: 0,
    ExcludeFromCoupons: 0,
    ShippingClass: 0,
    EnableReviews: 0,
    AvailableForPOS: 0,
    AvailableForWholesale: 0,
    PriceAmount: 0,
    SalePrice: 0,
    WholesalePrice: 0,
    Height: 0,
    Width: 0,
    Depth: 0,
    Weight: 0,
    DeclaredVaue: 0,
    StartDate: "",
    EndDate: "",
    Length: 0,
    Gauge: 0,
    RCTime: 0,
    IsOnSale: 0,
    SaleStartsOn: "",
    SaleEndsOn: "",
    SaleAnnouncement: "",
    IsOnOffer: 0,
    OfferAnnouncement: "",
    OfferText: "",
    OfferMinQty: 0,
    OfferFreeQty: 0,
    OfferStarts: "",
    OfferEnds: "",
    WhatsIncluded: "",
    ExternalDimension: "",
    UseCase: "",
    DeliveryInfo: "",
    ObjectSchema: "",
  });

  useEffect(() => {
    getObjectAdminListData(0, 0);
    getObjectAdminData(0, 0);
  }, [selectedStatus]);

  function getObjectAdminListData(add: any, pid: any) {
    let object = {} as any;
    object.type = 13;
    object.add = add;
    object.pid = pid;
    object.status = selectedStatus;
    axiosAuth
      .post(AppContext.APIURL + "api/PTProduct/GetProductAdminData", object)
      .then((response) => {
        if (response.data.Status === 1) {
          var l_response = response.data.Data;
          setProductListsData(l_response);
        } else {
          console.log("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function getObjectAdminData(add: any, pid: any) {
    let object = {} as any;
    object.type = type;
    object.add = add;
    object.pid = pid;
    object.status = selectedStatus;
    setShowAnimation(true);
    setEditMode(0);
    axiosAuth
      .post(AppContext.APIURL + "api/PTProduct/GetProductAdminData", object)
      .then((response) => {
        if (response.data.Status === 1) {
          var l_response = response.data.Data;
          console.log("Product Data: ", l_response[0]);
          setObjectAdminData(l_response[0]);
          const deepCopy1 = JSON.parse(JSON.stringify(l_response));
          const deepCopy2 = JSON.parse(JSON.stringify(l_response));
          setThisGridListDataWithoutFilters(deepCopy1[0]);
          //setObjectAdminData(deepCopy1[0]);
          setThisGridListData(deepCopy2[0]);
          thisGridListDataRef.current = deepCopy2[0];
        } else {
          console.log("error", response.data.Message);
        }
        setShowAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function displayAddModal() {
    // setShowAddNewModal(true);
    addNewRecord();
    setSelectedProductType(0);
    setSelectedParentID(0);
  }

  function addNewRecord() {
    setShowAddNewModal(false);
    setAddEditObject({
      PTProductID: 0,
      PTProductCategoryID: 0,
      PTProductStatusID: 0,
      PTProductAvailabilityID: 0,
      PTProductTaxClassID: 0,
      PTProductTaxStatusID: 0,
      Name: "",
      Description: "",
      ShortDescription: "",
      URLFriendlyName: "",
      MainImageURL: "",
      ThumbnailURL: "",
      BackgroundImage: "",
      MetaKeywords: "",
      MetaTitle: "",
      MetaDescription: "",
      PTOrderBy: 0,
      VisibilityStatus: 0,
      Binder: "",
      Filter: "",
      ParentID: 0,
      Strength: 0,
      Wrapper: "",
      PurchaseNote: "",
      SKU: "",
      ExternalID: 0,
      IsFree: 0,
      IsActive: 0,
      OrderLimit: 0,
      Envelope: 0,
      ExcludeFromCoupons: 0,
      ShippingClass: 0,
      EnableReviews: 0,
      AvailableForPOS: 0,
      AvailableForWholesale: 0,
      PriceAmount: 0,
      SalePrice: 0,
      WholesalePrice: 0,
      Height: 0,
      Width: 0,
      Depth: 0,
      Weight: 0,
      DeclaredVaue: 0,
      StartDate: "",
      EndDate: "",
      Length: 0,
      Gauge: 0,
      RCTime: 0,
      IsOnSale: 0,
      SaleStartsOn: "",
      SaleEndsOn: "",
      SaleAnnouncement: "",
      IsOnOffer: 0,
      OfferAnnouncement: "",
      OfferText: "",
      OfferMinQty: 0,
      OfferFreeQty: 0,
      OfferStarts: "",
      OfferEnds: "",
      WhatsIncluded: "",
      ExternalDimension: "",
      UseCase: "",
      DeliveryInfo: "",
      ObjectSchema: "",
    });
    setEditMode(1);
    setInformationTab(1);
    setSelectedRelatedProductID(0);
    setProductTab(1);
  }

  function getDataForEdit(add: any, pid: any, reload = true) {
    let object = {} as any;
    object.type = type;
    object.add = add;
    object.pid = pid;
    object.status = selectedStatus;
    setShowAnimation(true);
    axiosAuth
      .post(AppContext.APIURL + "api/PTProduct/GetProductAdminData", object)
      .then((response) => {
        if (response.data.Status === 1) {
          var l_response = response.data.Data;
          console.log("Edit Product Data: ", l_response);
          setAddEditObject(l_response[0][0]);
          setImagesData(l_response[1]);
          setRelatedProductsData(l_response[2]);
          if (reload == true) {
            setEditMode(2);
            setInformationTab(1);
            setProductTab(1);
          }
        } else {
          console.log("error", response.data.Message);
        }
        setShowAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function updateValue(value: any, index: any, colName: string) {
    let thisobjectAdminData: any = [...thisGridListData];
    thisobjectAdminData[index][colName] = value;
    setObjectAdminData(thisobjectAdminData);
  }
  function updateValueImages(value: any, index: any, colName: string) {
    let thisobjectAdminData: any = [...imagesData];
    thisobjectAdminData[index][colName] = value;
    setImagesData(thisobjectAdminData);
  }
  function updateValueRelatedProduct(value: any, index: any, colName: string) {
    let thisobjectAdminData: any = [...relatedProductsData];
    thisobjectAdminData[index][colName] = value;
    setRelatedProductsData(thisobjectAdminData);
  }

  function checkValidation(
    typeid: any,
    pid: any,
    colvalue: string,
    colname: any,
  ) {
    let isOkayToGo = true;
    let Message = "";
    if (addEditObject.PTProductCategoryID == 0) {
      isOkayToGo = false;
      Message += "<br /> <span>Category Required</span>";
    }
    if (addEditObject.Name == "") {
      isOkayToGo = false;
      Message += "<br /> <span>Name Required</span>";
    }
    if (addEditObject.PTProductStatusID == 0) {
      isOkayToGo = false;
      Message += "<br /> <span>Status Required</span>";
    }
    if (addEditObject.PTProductAvailabilityID == 0) {
      isOkayToGo = false;
      Message += "<br /> <span>Stock Status Required</span>";
    }
    if (isOkayToGo == false) {
      globalState.setNotificationObject({
        ShowPopup: true,
        Heading: "Alert",
        Message: Message,
      });
    } else {
      updateObjectAdminData(typeid, pid, colvalue, colname);
    }
  }

  function updateObjectAdminData(
    typeid: any,
    pid: any,
    colvalue: any,
    colname: any,
  ) {
    let object = {} as any;
    object.type = typeid;
    object.pid = pid;
    object.colname = colname;
    object.colvalue = colvalue;
    object.catid = addEditObject.PTProductCategoryID;
    object.name = typeid == 40 || typeid == 50 ? "" : addEditObject.Name;
    object.description = addEditObject.Description;
    object.ufurl = addEditObject.URLFriendlyName;
    object.visibilitystatus = addEditObject.VisibilityStatus;
    object.ordering = addEditObject.PTOrderBy;
    object.strength = addEditObject.Strength;
    object.shortdescription = addEditObject.ShortDescription;
    object.th = addEditObject.ThumbnailURL;
    object.main = addEditObject.MainImageURL;
    object.bg = addEditObject.BackgroundImage;

    object.priceamount = addEditObject.PriceAmount;
    object.saleprice = addEditObject.SalePrice;
    object.wholesaleprice = addEditObject.WholesalePrice;
    object.productstatus = addEditObject.PTProductStatusID;
    object.productavailability = addEditObject.PTProductAvailabilityID;
    object.producttaxclass = addEditObject.PTProductTaxClassID;
    object.producttaxstatus = addEditObject.PTProductTaxStatusID;
    object.excludefromcoupons = addEditObject.ExcludeFromCoupons;
    object.sku = addEditObject.SKU;
    object.externalid = addEditObject.ExternalID;
    object.orderlimit = addEditObject.OrderLimit;
    object.weight = addEditObject.Weight;
    object.height = addEditObject.Height;
    object.width = addEditObject.Width;
    object.depth = addEditObject.Depth;
    object.declaredvaue = addEditObject.DeclaredVaue;
    object.shippingclass = addEditObject.ShippingClass;
    object.length = addEditObject.Length;
    object.gauge = addEditObject.Gauge;
    object.rctime = addEditObject.RCTime;
    object.purchasenote = addEditObject.PurchaseNote;
    object.enablereviews = addEditObject.EnableReviews;
    object.availableforpos = addEditObject.AvailableForPOS;
    object.availableforwholesale = addEditObject.AvailableForWholesale;
    object.parentid = addEditObject.ParentID;

    object.wrapper = addEditObject.Wrapper;
    object.binder = addEditObject.Binder;
    object.filter = addEditObject.Filter;
    object.metatitle = addEditObject.MetaTitle;
    object.metakeyswords = addEditObject.MetaKeywords;
    object.metadescription = addEditObject.MetaDescription;

    object.isonsale = addEditObject.IsOnSale;
    object.salestartson = addEditObject.SaleStartsOn;
    object.saleendson = addEditObject.SaleEndsOn;
    object.saleannouncement = addEditObject.SaleAnnouncement;
    object.isonoffer = addEditObject.IsOnOffer;
    object.offerannouncement = addEditObject.OfferAnnouncement;
    object.offertext = addEditObject.OfferText;
    object.offerminqty = addEditObject.OfferMinQty;
    object.offerfreeqty = addEditObject.OfferFreeQty;
    object.offerstarts = addEditObject.OfferStarts;
    object.offerends = addEditObject.OfferEnds;
    object.whatsincluded = addEditObject.WhatsIncluded;
    object.externaldimension = addEditObject.ExternalDimension;
    object.usecase = addEditObject.UseCase;
    object.deliveryinfo = addEditObject.DeliveryInfo;

    setShowAnimation(true);
    axiosAuth
      .post(AppContext.APIURL + "api/PTProduct/UpdateProductAdminData", object)
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
          var l_response = response.data.Data[0][0];
          if (l_response.Status == 1) {
            if (typeid == 40 || typeid == 50) {
              if (colname != "Name" && colname != "imgsrc")
                getDataForEdit(0, addEditObject.PTProductID, false);
            } else if (
              colname != "PTProductCategoryID" &&
              colname != "PTProductStatusID" &&
              colname != "PTProductAvailabilityID" &&
              colname != "PTProductTaxClassID" &&
              colname != "PTProductTaxStatusID" &&
              colname != "PurchaseNote" &&
              colname != "ObjectSchema"
            ) {
              getObjectAdminData(0, 0);
            }
            setSelectedRelatedProductID(0);
          } else {
            globalState.setNotificationObject({
              ShowPopup: true,
              Heading: "Alert",
              Message: l_response.Message,
            });
          }
        } else {
          console.log("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function ConfirmationModalCallBack(obj: any) {
    if (obj.ID === 1) {
      if (obj.isConfirm === true) {
        updateObjectAdminData(35, obj.SelectedID, "", "del");
      }
    }
    if (obj.ID === 2) {
      if (obj.isConfirm === true) {
        updateObjectAdminData(40, obj.SelectedID, "", "delimage");
      }
    }

    if (obj.ID === 3) {
      if (obj.isConfirm === true) {
        updateObjectAdminData(50, obj.SelectedID, "", "delprod");
      }
    }

    if (obj.ID === 100) {
      if (obj.isConfirm === true) {
        updateObjectAdminData(type, obj.SelectedID, "", "archive");
      }
    }

    if (obj.ID === 101) {
      if (obj.isConfirm === true) {
        updateObjectAdminData(type, obj.SelectedID, "", "undoarchive");
      }
    }

    globalState.setConfirmationModalObject({
      ShowPopup: false,
      Heading: "",
      Message: "",
      ID: 0,
      SelectedID: 0,
      OtherID: 0,
    });
  }

  ///--States for columnFilter components---///
  const [clearFilters, setClearFilters] = useState(false);
  const [refreshFilters, setRefreshFilters] = useState(false);
  const [getFilteredLists, setGetFilteredLists] = useState(false);
  const [selectedColumnName, setSelectedColumnName] = useState("");
  const [thisGridListDataWithoutFilters, setThisGridListDataWithoutFilters] =
    useState<any>([]);
  const [thisGridListData, setThisGridListData] = useState<any>([]);
  const thisGridListDataRef = useRef<any | null>(null);
  thisGridListDataRef.current = thisGridListData;
  const [clickPosition, setClickPosition] = useState<any>({ x: null, y: null });
  function ShowColumnFilterList(event: any, Name: string) {
    if (Name === selectedColumnName) {
      setSelectedColumnName("");
    } else {
      setClickPosition({
        x: event.clientX,
        y: event.clientY,
        totalWidth: window.innerWidth,
        totalHeight: window.innerHeight,
      });
      setSelectedColumnName(Name);
    }
  }

  function filterCheckboxListCallback(FilterData: any) {
    setSelectedColumnName("");
    let l_data = []; //[...COPAInvoicesGridData] as any;
    l_data = [...FilterData];
    //setCOPAInvoicesGridData([...l_data]);

    setThisGridListData([...FilterData]);
    thisGridListDataRef.current = [...FilterData];
  }

  function ClearAllFilters() {
    const deepCopy = JSON.parse(JSON.stringify(thisGridListDataWithoutFilters));
    //setObjectAdminData(deepCopy[0]);
    setThisGridListData(deepCopy);
    // thisGridListDataRef.current = deepCopy[0];
    setClearFilters(!clearFilters);
  }

  //--States for columnFilter components---///

  //--States for columnFilter components---///

  const [filters, setFilters] = useState(["", "D"]);

  useLayoutEffect(() => {
    SetSortingImage(); // Called after DOM update but before paint
  }, [thisGridListData]);

  function SetSortingImage() {
    if (thisGridListData && thisGridListData.length > 0) {
      if (document.getElementById("imgSortName")) {
        (document.getElementById("imgSortName") as HTMLInputElement).innerHTML =
          '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
      }
    }
    var l_strClassimgAdd =
      '<img src="images/asc.svg" width="10px" height="13px" alt="B"/>';
    if (filters[1] == "D") {
      l_strClassimgAdd =
        '<img src="images/desc.svg" width="10px" height="13px" alt="B"/>';
    }
    if (filters[0] != "")
      (
        document.getElementById("imgSort" + filters[0]) as HTMLInputElement
      ).innerHTML = l_strClassimgAdd;
  }

  function LoadWithSelectedSort(p_strColumnName: any) {
    var l_strSortExpression = filters[0];
    var l_strSortDirection = filters[1];
    if (l_strSortExpression == p_strColumnName) {
      if (l_strSortDirection == "D") {
        filters[1] = "A";
      } else {
        filters[1] = "D";
      }
    } else {
      filters[1] = "D";
    }
    filters[0] = p_strColumnName;
    HandleSortAndLoadData();

    SetSortingImage();
  }

  function HandleSortAndLoadData() {
    if (filters[0] != "") {
      var SortedGridData = SortTheList(
        thisGridListDataRef.current,
        filters[0],
        filters[1],
      );
      HandleDataLoad(SortedGridData);
    } else {
      HandleDataLoad(thisGridListDataRef.current);
    }
  }

  function HandleDataLoad(GridData: any) {
    let data: any = [...GridData];
    setThisGridListData(data);
    SetSortingImage();
  }

  ////  Sorting Ends    ////

  function setURLFriendlyName(name: string) {
    let URLFriendlyName = GetRefindURLPage(name);

    setAddEditObject((prevState: any) => ({
      ...prevState,
      URLFriendlyName: URLFriendlyName,
    }));
  }

  function filterProductList() {
    const relatedIds = relatedProductsData.map((r: any) => r.RelatedProductID);
    const result = objectAdminData.filter(
      (p: any) =>
        p.PTProductID !== addEditObject.PTProductID &&
        !relatedIds.includes(p.PTProductID),
    );

    return result;
  }

  function updatePTProductCategoryID(parentID: any) {
    let ProductCategoryID = 0;
    let data = [...thisGridListDataWithoutFilters];
    for (let index = 0; index < data.length; index++) {
      if (data[index].PID == parentID) {
        ProductCategoryID = data[index].PTProductCategoryID;
        break;
      }
    }

    setAddEditObject((prevState: any) => ({
      ...prevState,
      PTProductCategoryID: ProductCategoryID,
    }));
  }

  return (
    <div className="inline-block-d width-100 p-all10">
      <ConfirmationModal
        ConfirmationObject={globalState.ConfirmationModalObject}
        ConfirmationModalCallBack={ConfirmationModalCallBack}
      />
      {objectAdminData && objectAdminData.length > 0 && (
        <ColumnFilterCheckboxList
          DataType={1}
          RefreshFilters={refreshFilters}
          ClearFilters={clearFilters}
          GridData={objectAdminData}
          ColumnName={selectedColumnName}
          ColumnFilterCheckboxListCallback={filterCheckboxListCallback}
          GetFilteredLists={getFilteredLists}
          ReturnAllFilterdLists={{}}
          ClickPosition={clickPosition}
          Orientation={"Center"}
          ColumnOrientation={[{ Name: "Name", Orientation: "Right" }]}
        />
      )}

      {showAnimation && <LoadingAnimation />}

      {/* <div className="page--breadcrumb flex-jsb">
          <a>Product</a>
        </div> */}

      <div className="flex-d justify-btw mb-10">
        <span></span>
        {editMode == 0 && (
          <div className="flex-daj flex-gap10">
            <a
              className="link-btn btn-link-m"
              onClick={() => ClearAllFilters()}
            >
              Clear All Filters
            </a>
            {locked == false && (
              <>
                <div className="com-toggle">
                  <span className="txt-compare bold-font">Show Order</span>

                  <a
                    className={showOrders ? "com-btn com-sel" : "com-btn"}
                    onClick={() => {
                      setShowOrders(!showOrders);
                    }}
                  >
                    <span></span>
                  </a>
                </div>

                <div className="flex-daj btn-start">
                  <a
                    className="btn-primary flex-daj"
                    onClick={() => displayAddModal()}
                  >
                    Add New
                  </a>
                </div>
              </>
            )}
            <a
              className="btn-primary flex-daj btn-grid no-display"
              title="Export"
              onClick={() =>
                DownloadClientsDataInExcel("tblprodcat", "Product")
              }
            >
              <img src="images/export.svg" width="18" height="18" />
            </a>

            <LockUnlockV2 locked={locked} setLocked={setLocked} />
          </div>
        )}
      </div>

      {editMode == 0 && (
        <div className="flow-auto">
          <table className="reuse-table" id="tblprodcat">
            <thead>
              <tr>
                <th className="td-sm">
                  <div className="flex-daj flex-gap20">
                    <div className="flex-da flex-gap10">
                      Name
                      <a
                        onClick={(e) => ShowColumnFilterList(e, "Name")}
                        data-function="ShowColumnFilterList"
                      >
                        <img
                          src="images/icon-search-w.svg"
                          width={15}
                          height={15}
                          alt="search"
                        />
                      </a>
                      <a
                        onClick={() => LoadWithSelectedSort("Name")}
                        title="Sort By Name"
                      >
                        <span id="imgSortName">
                          <img
                            src="images/none.svg"
                            width="10px"
                            height="13px"
                            alt="B"
                          />
                        </span>
                      </a>
                    </div>
                  </div>
                </th>
                {/* <th>
                  Description
                </th> */}
                <th className="td-xxs">
                  <div className="flex-daj flex-gap20">
                    <div className="flex-da flex-gap10">
                      Product Code
                      <a
                        onClick={(e) => ShowColumnFilterList(e, "SKU")}
                        data-function="ShowColumnFilterList"
                      >
                        <img
                          src="images/icon-search-w.svg"
                          width={15}
                          height={15}
                          alt="search"
                        />
                      </a>
                    </div>
                  </div>
                </th>

                <th className="td-xs">Category</th>
                <th className="td-xxs">Status</th>
                <th className="td-xxs">Availability</th>
                {/* <th className="reused-tdxs sticky-header">Tax Class</th>
                      <th className="reused-tdxs sticky-header">Tax Status</th> */}
                <th className="td-xxs">Main Image</th>
                <th className="td-xxs">Ordering</th>
                <th className="td-xxs">Action</th>
              </tr>
            </thead>
            <tbody>
              {thisGridListData &&
                thisGridListData.map((item: any, index: any) => (
                  <React.Fragment key={index}>
                    {!item.IsExcluded && (
                      <tr>
                        <td>{item.Name}</td>
                        <td>{item.SKU}</td>
                        <td>
                          <select
                            disabled={locked}
                            value={item.PTProductCategoryID}
                            onChange={(e) => {
                              updateValue(
                                e.target.value,
                                index,
                                "PTProductCategoryID",
                              );
                              updateObjectAdminData(
                                35,
                                item.PID,
                                e.target.value,
                                "PTProductCategoryID",
                              );
                            }}
                            className="text-left"
                          >
                            <option value="0">Select</option>
                            {productListsData[0] &&
                              productListsData[0].map(
                                (item: any, index: any) => (
                                  <React.Fragment key={index}>
                                    <option value={item.PID}>
                                      {item.Name}
                                    </option>
                                  </React.Fragment>
                                ),
                              )}
                          </select>
                        </td>
                        <td className="p-all0">
                          <select
                            disabled={locked}
                            value={item.PTProductStatusID}
                            onChange={(e) => {
                              updateValue(
                                e.target.value,
                                index,
                                "PTProductStatusID",
                              );
                              updateObjectAdminData(
                                35,
                                item.PID,
                                e.target.value,
                                "PTProductStatusID",
                              );
                            }}
                            className="text-left"
                          >
                            <option value="0">Select</option>
                            {productListsData[1] &&
                              productListsData[1].map(
                                (item: any, index: any) => (
                                  <React.Fragment key={index}>
                                    <option value={item.PID}>
                                      {item.Name}
                                    </option>
                                  </React.Fragment>
                                ),
                              )}
                          </select>
                        </td>
                        <td className="p-all0">
                          <select
                            disabled={locked}
                            value={item.PTProductAvailabilityID}
                            onChange={(e) => {
                              updateValue(
                                e.target.value,
                                index,
                                "PTProductAvailabilityID",
                              );
                              updateObjectAdminData(
                                35,
                                item.PID,
                                e.target.value,
                                "PTProductAvailabilityID",
                              );
                            }}
                            className="text-left"
                          >
                            <option value="0">Select</option>
                            {productListsData[2] &&
                              productListsData[2].map(
                                (item: any, index: any) => (
                                  <React.Fragment key={index}>
                                    <option value={item.PID}>
                                      {item.Name}
                                    </option>
                                  </React.Fragment>
                                ),
                              )}
                          </select>
                        </td>
                        {/* <td className="p-all0">
                                <select
                                  disabled={locked}
                                  value={item.PTProductTaxClassID}
                                  onChange={(e) => {
                                    updateValue(
                                      e.target.value,
                                      index,
                                      "PTProductTaxClassID",
                                    );
                                    updateObjectAdminData(
                                      35,
                                      item.PID,
                                      e.target.value,
                                      "PTProductTaxClassID",
                                    );
                                  }}
                                >
                                  <option value="0">Select</option>
                                  {productListsData[3] &&
                                    productListsData[3].map(
                                      (item: any, index: any) => (
                                        <React.Fragment key={index}>
                                          <option value={item.PID}>
                                            {item.Name}
                                          </option>
                                        </React.Fragment>
                                      ),
                                    )}
                                </select>
                              </td>
                              <td className="p-all0">
                                <select
                                  disabled={locked}
                                  value={item.PTProductTaxStatusID}
                                  onChange={(e) => {
                                    updateValue(
                                      e.target.value,
                                      index,
                                      "PTProductTaxStatusID",
                                    );
                                    updateObjectAdminData(
                                      35,
                                      item.PID,
                                      e.target.value,
                                      "PTProductTaxStatusID",
                                    );
                                  }}
                                >
                                  <option value="0">Select</option>
                                  {productListsData[4] &&
                                    productListsData[4].map(
                                      (item: any, index: any) => (
                                        <React.Fragment key={index}>
                                          <option value={item.PID}>
                                            {item.Name}
                                          </option>
                                        </React.Fragment>
                                      ),
                                    )}
                                </select>
                              </td> */}
                        <td className="p-all5 p-all5">
                          {item.MainImageURL != "" && (
                            <div className="flex-daj">
                              <div className="contact-attachments m-0">
                                <div className="remove--image">
                                  <img
                                    src={GetThumbnailImage(item.MainImageURL)}
                                    alt="img"
                                    width="150"
                                    height="50"
                                    style={{ width: "auto" }}
                                  />
                                </div>
                              </div>
                            </div>
                          )}
                        </td>
                        <td className="text-center">
                          <div className="flex-daj flex-gap10">
                            <button
                              className="no-borbg pointer"
                              disabled={index == 0 || locked ? true : false}
                              title="Up"
                              onClick={(e) =>
                                updateObjectAdminData(
                                  35,
                                  item.PID,
                                  "up",
                                  "PTOrderBy",
                                )
                              }
                            >
                              <img
                                src="images/o-up.svg"
                                width="14px"
                                height="16px"
                                alt="up"
                              />
                            </button>
                            <button
                              className="no-borbg pointer"
                              disabled={
                                index == thisGridListData.length - 1 || locked
                                  ? true
                                  : false
                              }
                              title="Down"
                              onClick={(e) =>
                                updateObjectAdminData(
                                  35,
                                  item.PID,
                                  "down",
                                  "PTOrderBy",
                                )
                              }
                            >
                              <img
                                src="images/o-down.svg"
                                width="14px"
                                height="16px"
                                alt="down"
                              />
                            </button>

                            {showOrders && (
                              <>
                                <input
                                  className="text-right"
                                  disabled={locked}
                                  value={item.PTOrderBy}
                                  onChange={(e) =>
                                    updateValue(
                                      e.target.value,
                                      index,
                                      "PTOrderBy",
                                    )
                                  }
                                  onBlur={(e) =>
                                    updateObjectAdminData(
                                      35,
                                      item.PID,
                                      e.target.value,
                                      "PTOrderBy",
                                    )
                                  }
                                />
                              </>
                            )}
                          </div>
                        </td>
                        <td className="text-center">
                          <div className="flex-daj flex-gap10">
                            <button
                              title="Edit"
                              className="no-borbg pointer"
                              onClick={() => getDataForEdit(0, item.PID)}
                            >
                              <img
                                src="images/edit.svg"
                                width="17px"
                                height="17px"
                                alt="Edit"
                              />
                            </button>
                            <button
                              title="Delete"
                              className="no-borbg pointer"
                              disabled={locked}
                              onClick={() =>
                                globalState.setConfirmationModalObject({
                                  ShowPopup: true,
                                  Heading: "Alert",
                                  Message:
                                    "Are your sure, you want to delete this record?",
                                  ID: 1,
                                  SelectedID: item.PID,
                                  OtherID: 0,
                                })
                              }
                            >
                              <img
                                src="images/delete.png"
                                width="17px"
                                height="17px"
                                alt="Edit"
                              />
                            </button>
                          </div>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                ))}
            </tbody>
          </table>
        </div>
      )}

      {editMode > 0 && (
        <div className="inline-block-d text-center width-100 reuse-border p-all20">
          <div className="flex-da justify-btw mb-10">
            <h3 className="font-16 bold-font m-0">
              {editMode == 1 ? "Add New Product" : "Update Product"}
            </h3>
            {editMode == 2 && (
              <div className="copy-tab copy-tab2">
                <a
                  onClick={() => setInformationTab(1)}
                  className={`name-count ${
                    informationTab === 1 ? "selected" : ""
                  }`}
                >
                  Information
                </a>

                <a
                  className={`name-count ${
                    informationTab === 2 ? "selected" : ""
                  }`}
                  onClick={() => setInformationTab(2)}
                >
                  Images
                </a>
                <a
                  className={`name-count ${
                    informationTab === 5 ? "selected" : ""
                  }`}
                  onClick={() => setInformationTab(5)}
                >
                  Product Schema
                </a>
                <a
                  style={{ borderLeft: "1px solid #64278c" }}
                  className={`name-count ${
                    informationTab === 3 ? "selected" : ""
                  }`}
                  onClick={() => setInformationTab(3)}
                >
                  Related Products
                </a>

                <a
                  style={{ borderLeft: "1px solid #64278c" }}
                  className={`name-count ${
                    informationTab === 4 ? "selected" : ""
                  }`}
                  onClick={() => setInformationTab(4)}
                >
                  FAQs
                </a>
              </div>
            )}
          </div>

          {informationTab == 1 && (
            <>
              {productTab == 1 && (
                <>
                  <div className="grid-d fr-1111 gap-20 mt-20 flex-as">
                    <div className="field-input grid-d flex-gap3">
                      <span className="font-12 text-left label-color">
                        Category:
                      </span>
                      <select
                        className="input-field w-100"
                        disabled={addEditObject.ParentID > 0 ? true : false}
                        value={addEditObject.PTProductCategoryID}
                        onChange={(e) =>
                          setAddEditObject((prevState: any) => ({
                            ...prevState,
                            PTProductCategoryID: e.target.value,
                          }))
                        }
                      >
                        <option value="0">Select</option>
                        {productListsData[0] &&
                          productListsData[0].map((item: any, index: any) => (
                            <React.Fragment key={index}>
                              <option value={item.PID}>{item.Name}</option>
                            </React.Fragment>
                          ))}
                      </select>
                    </div>

                    <div className="field-input grid-d flex-gap3">
                      <span className="font-12 text-left label-color">
                        Stock Status:
                      </span>
                      <select
                        className="input-field w-100"
                        value={addEditObject.PTProductAvailabilityID}
                        onChange={(e) =>
                          setAddEditObject((prevState: any) => ({
                            ...prevState,
                            PTProductAvailabilityID: e.target.value,
                          }))
                        }
                      >
                        <option value="0">Select</option>
                        {productListsData[2] &&
                          productListsData[2].map((item: any, index: any) => (
                            <React.Fragment key={index}>
                              <option value={item.PID}>{item.Name}</option>
                            </React.Fragment>
                          ))}
                      </select>
                    </div>

                    <div className="field-input grid-d flex-gap3">
                      <span className="font-12 text-left label-color">
                        Status:
                      </span>
                      <select
                        className="input-field w-100"
                        value={addEditObject.PTProductStatusID}
                        onChange={(e) =>
                          setAddEditObject((prevState: any) => ({
                            ...prevState,
                            PTProductStatusID: e.target.value,
                          }))
                        }
                      >
                        <option value="0">Select</option>
                        {productListsData[1] &&
                          productListsData[1].map((item: any, index: any) => (
                            <React.Fragment key={index}>
                              <option value={item.PID}>{item.Name}</option>
                            </React.Fragment>
                          ))}
                      </select>
                    </div>
                    <div className="field-input grid-d flex-gap3">
                      <span className="font-12 text-left label-color">
                        Price:
                      </span>
                      <input
                        className="input-field w-100"
                        value={addEditObject.PriceAmount}
                        onChange={(e) =>
                          setAddEditObject((prevState: any) => ({
                            ...prevState,
                            PriceAmount: e.target.value,
                          }))
                        }
                      />
                    </div>
                    <div className="field-input grid-d flex-gap3">
                      <span className="font-12 text-left label-color">
                        Name:
                      </span>
                      <input
                        className="input-field w-100"
                        value={addEditObject.Name}
                        onChange={(e) =>
                          setAddEditObject((prevState: any) => ({
                            ...prevState,
                            Name: e.target.value,
                          }))
                        }
                        onBlur={(e) => setURLFriendlyName(e.target.value)}
                      />
                    </div>
                    <div className="field-input grid-d flex-gap3">
                      <span className="font-12 text-left label-color">
                        URL Friendly Name / Product Details Link:
                      </span>
                      <input
                        className="input-field w-100"
                        value={addEditObject.URLFriendlyName}
                        onChange={(e) =>
                          setAddEditObject((prevState: any) => ({
                            ...prevState,
                            URLFriendlyName: e.target.value,
                          }))
                        }
                        onBlur={(e) => setURLFriendlyName(e.target.value)}
                      />
                    </div>
                    <div className="field-input grid-d flex-gap3">
                      <span className="font-12 text-left label-color">
                        Product Code:
                      </span>
                      <input
                        className="input-field w-100"
                        value={addEditObject.SKU}
                        onChange={(e) =>
                          setAddEditObject((prevState: any) => ({
                            ...prevState,
                            SKU: e.target.value,
                          }))
                        }
                      />
                    </div>
                  </div>

                  <div className="grid-d fr-1 mt-20 flex-gap20">
                    <div className="field-input grid-d flex-gap3">
                      <span className="font-12 text-left label-color">
                        Short Description:
                      </span>

                      <div className="ck-editor-container">
                        <QuillEditor
                          value={addEditObject.ShortDescription}
                          onChange={(value: string) =>
                            setAddEditObject((prev: any) => ({
                              ...prev,
                              ShortDescription: value,
                            }))
                          }
                        />
                      </div>
                    </div>
                    <div className="field-input grid-d flex-gap3">
                      <span className="font-12 text-left label-color">
                        Description:
                      </span>

                      <div className="ck-editor-container">
                        <QuillEditor
                          value={addEditObject.Description}
                          onChange={(value: string) =>
                            setAddEditObject((prev: any) => ({
                              ...prev,
                              Description: value,
                            }))
                          }
                        />
                      </div>
                    </div>
                  </div>

                  <div className="grid-d fr-11 mt-20 flex-gap20 flex-as">
                    <div className="field-input grid-d flex-gap3">
                      <span className="font-12 text-left label-color flex-da flex-gap10">
                        Thumbnail Image
                        <a
                          title="Manage Content Library"
                          className="flex-d library-btn"
                          onClick={() => setShowContentLibraryModal(true)}
                        >
                          <img
                            src="images/m-manage.svg"
                            width="18px"
                            height="18px"
                            alt="Edit"
                          />
                        </a>
                        <span className="notify-Bold">
                          &#40;Display Size: width=228px, Height:200px&#41;
                        </span>
                      </span>
                      <input
                        className="input-field w-100"
                        value={addEditObject.ThumbnailURL}
                        onChange={(e) =>
                          setAddEditObject((prevState: any) => ({
                            ...prevState,
                            ThumbnailURL: e.target.value,
                          }))
                        }
                      />
                      {addEditObject.ThumbnailURL != "" && (
                        <div className="contact-attachments">
                          <div className="remove--image">
                            <img
                              src={GetThumbnailImage(
                                addEditObject.ThumbnailURL,
                              )}
                              alt="img"
                              width="200"
                              height="100"
                              style={{ width: "auto" }}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="field-input grid-d flex-gap3">
                      <span className="font-12 text-left label-color flex-da flex-gap10">
                        Main Image:{" "}
                        <a
                          title="Manage Content Library"
                          className="flex-d library-btn"
                          onClick={() => setShowContentLibraryModal(true)}
                        >
                          <img
                            src="images/m-manage.svg"
                            width="18px"
                            height="18px"
                            alt="Edit"
                          />
                        </a>
                        <span className="notify-Bold">
                          &#40;Display Size: width=498px, Height:406px&#41;
                        </span>
                      </span>
                      <input
                        className="input-field w-100"
                        value={addEditObject.MainImageURL}
                        onChange={(e) =>
                          setAddEditObject((prevState: any) => ({
                            ...prevState,
                            MainImageURL: e.target.value,
                          }))
                        }
                      />
                      {addEditObject.MainImageURL != "" && (
                        <div className="contact-attachments">
                          <div className="remove--image">
                            <img
                              src={GetThumbnailImage(
                                addEditObject.MainImageURL,
                              )}
                              alt="img"
                              width="200"
                              height="100"
                              style={{ width: "auto" }}
                            />
                          </div>
                        </div>
                      )}
                    </div>

                    {/* <div className="field-input grid-d flex-gap3">
                                <span className="font-12 text-left label-color flex-da flex-gap10">
                                  Background Image:{" "}
                                  <a
                                    title="Manage Content Library"
                                    className="flex-d library-btn"
                                    onClick={() =>
                                      setShowContentLibraryModal(true)
                                    }
                                  >
                                    <img
                                      src="images/m-manage.svg"
                                      width="18px"
                                      height="18px"
                                      alt="Edit"
                                    />
                                  </a>
                                </span>
                                <input
                                  className="input-field w-100"
                                  value={addEditObject.BackgroundImage}
                                  onChange={(e) =>
                                    setAddEditObject((prevState: any) => ({
                                      ...prevState,
                                      BackgroundImage: e.target.value,
                                    }))
                                  }
                                />
                                {addEditObject.BackgroundImage != "" && (
                                  <div className="contact-attachments">
                                    <div className="remove--image">
                                      <img
                                        src={GetThumbnailImage(
                                          addEditObject.BackgroundImage,
                                        )}
                                        alt="img"
                                        width="200"
                                        height="100"
                                        style={{ width: "auto" }}
                                      />
                                    </div>
                                  </div>
                                )}
                              </div> */}
                  </div>

                  <div className="grid-d fr-7f mt-20 flex-gap20 flex-as">
                    {/* <div className="field-input grid-d flex-gap3">
                      <span className="font-12 text-left label-color">
                        Enable reviews:
                      </span>
                      <input
                        className="input-field"
                        type="checkbox"
                        checked={
                          addEditObject.EnableReviews == 1 ? true : false
                        }
                        onChange={(e) =>
                          setAddEditObject((prevState: any) => ({
                            ...prevState,
                            EnableReviews: e.target.checked == true ? 1 : 0,
                          }))
                        }
                        style={{
                          width: "18px",
                          height: "18px",
                          minHeight: "18px",
                          margin: "0",
                        }}
                      />
                    </div> */}

                    <div className="field-input grid-d flex-gap3">
                      <span className="font-12 text-left label-color">
                        Enable Sale:
                      </span>
                      <input
                        className="input-field"
                        type="checkbox"
                        checked={addEditObject.IsOnSale == 1 ? true : false}
                        onChange={(e) =>
                          setAddEditObject((prevState: any) => ({
                            ...prevState,
                            IsOnSale: e.target.checked == true ? 1 : 0,
                          }))
                        }
                        style={{
                          width: "18px",
                          height: "18px",
                          minHeight: "18px",
                          margin: "0",
                        }}
                      />
                    </div>

                    {addEditObject.IsOnSale == 1 && (
                      <>
                        <div className="field-input grid-d flex-gap3">
                          <span className="font-12 text-left label-color">
                            Sale price:
                          </span>
                          <input
                            className="input-field w-100"
                            style={{
                              appearance: "none",
                              height: "37px",
                            }}
                            value={addEditObject.SalePrice}
                            onChange={(e) =>
                              setAddEditObject((prevState: any) => ({
                                ...prevState,
                                SalePrice: e.target.value,
                              }))
                            }
                          />
                        </div>
                        <div className="field-input grid-d flex-gap3">
                          <span className="font-12 text-left label-color">
                            Sale Starts On:
                          </span>
                          <input
                            className="input-field w-100"
                            type="date"
                            value={moment(addEditObject.SaleStartsOn).format(
                              "YYYY-MM-DD",
                            )}
                            onChange={(e) =>
                              setAddEditObject((prevState: any) => ({
                                ...prevState,
                                SaleStartsOn: e.target.value,
                              }))
                            }
                          />
                        </div>
                        <div className="field-input grid-d flex-gap3">
                          <span className="font-12 text-left label-color">
                            Sale Ends On:
                          </span>
                          <input
                            type="date"
                            className="input-field w-100"
                            value={moment(addEditObject.SaleEndsOn).format(
                              "YYYY-MM-DD",
                            )}
                            onChange={(e) =>
                              setAddEditObject((prevState: any) => ({
                                ...prevState,
                                SaleEndsOn: e.target.value,
                              }))
                            }
                          />
                        </div>
                        <div className="field-input grid-d flex-gap3">
                          <span className="font-12 text-left label-color">
                            Sale Announcement:
                          </span>
                          <textarea
                            className="input-field w-100"
                            value={addEditObject.SaleAnnouncement}
                            onChange={(e) =>
                              setAddEditObject((prevState: any) => ({
                                ...prevState,
                                SaleAnnouncement: e.target.value,
                              }))
                            }
                          />
                        </div>
                      </>
                    )}
                  </div>
                  <div className="grid-d fr-7f mt-20 flex-gap20 flex-as">
                    <div className="field-input grid-d flex-gap3">
                      <span className="font-12 text-left label-color">
                        Enable Offer:
                      </span>
                      <input
                        className="input-field"
                        type="checkbox"
                        checked={addEditObject.IsOnOffer == 1 ? true : false}
                        onChange={(e) =>
                          setAddEditObject((prevState: any) => ({
                            ...prevState,
                            IsOnOffer: e.target.checked == true ? 1 : 0,
                          }))
                        }
                        style={{
                          width: "18px",
                          height: "18px",
                          minHeight: "18px",
                          margin: "0",
                        }}
                      />
                    </div>

                    {addEditObject.IsOnOffer == 1 && (
                      <>
                        <div className="field-input grid-d flex-gap3">
                          <span className="font-12 text-left label-color">
                            Offer Min Qty:
                          </span>
                          <input
                            className="input-field w-100"
                            value={addEditObject.OfferMinQty}
                            onChange={(e) =>
                              setAddEditObject((prevState: any) => ({
                                ...prevState,
                                OfferMinQty: e.target.value,
                              }))
                            }
                          />
                        </div>
                        <div className="field-input grid-d flex-gap3">
                          <span className="font-12 text-left label-color">
                            Offer Free Qty:
                          </span>
                          <input
                            className="input-field w-100"
                            value={addEditObject.OfferFreeQty}
                            onChange={(e) =>
                              setAddEditObject((prevState: any) => ({
                                ...prevState,
                                OfferFreeQty: e.target.value,
                              }))
                            }
                          />
                        </div>
                        <div className="field-input grid-d flex-gap3">
                          <span className="font-12 text-left label-color">
                            Offer Starts On:
                          </span>
                          <input
                            className="input-field w-100"
                            type="date"
                            value={moment(addEditObject.OfferStarts).format(
                              "YYYY-MM-DD",
                            )}
                            onChange={(e) =>
                              setAddEditObject((prevState: any) => ({
                                ...prevState,
                                OfferStarts: e.target.value,
                              }))
                            }
                          />
                        </div>
                        <div className="field-input grid-d flex-gap3">
                          <span className="font-12 text-left label-color">
                            Offer Ends On:
                          </span>
                          <input
                            type="date"
                            className="input-field w-100"
                            value={moment(addEditObject.OfferEnds).format(
                              "YYYY-MM-DD",
                            )}
                            onChange={(e) =>
                              setAddEditObject((prevState: any) => ({
                                ...prevState,
                                OfferEnds: e.target.value,
                              }))
                            }
                          />
                        </div>
                        <div className="field-input grid-d flex-gap3">
                          <span className="font-12 text-left label-color">
                            Offer Announcement:
                          </span>
                          <textarea
                            className="input-field w-100"
                            value={addEditObject.OfferAnnouncement}
                            onChange={(e) =>
                              setAddEditObject((prevState: any) => ({
                                ...prevState,
                                OfferAnnouncement: e.target.value,
                              }))
                            }
                          />
                        </div>
                        <div className="field-input grid-d flex-gap3">
                          <span className="font-12 text-left label-color">
                            Offer Text:
                          </span>
                          <textarea
                            className="input-field w-100"
                            value={addEditObject.OfferText}
                            onChange={(e) =>
                              setAddEditObject((prevState: any) => ({
                                ...prevState,
                                OfferText: e.target.value,
                              }))
                            }
                          />
                        </div>
                      </>
                    )}

                    {/* {addEditObject.IsOnOffer == 1 && (
                      <>
                        
                        
                      </>
                    )} */}
                  </div>

                  <div className="grid-d fr-1 mt-20 flex-gap20">
                    <div className="field-input grid-d flex-gap3">
                      <span className="font-12 text-left label-color">
                        Whats Included:
                      </span>

                      <div className="ck-editor-container">
                        <QuillEditor
                          value={addEditObject.WhatsIncluded}
                          onChange={(value: string) =>
                            setAddEditObject((prev: any) => ({
                              ...prev,
                              WhatsIncluded: value,
                            }))
                          }
                        />
                      </div>
                    </div>
                    <div className="field-input grid-d flex-gap3">
                      <span className="font-12 text-left label-color">
                        External Dimension:
                      </span>

                      <div className="ck-editor-container">
                        <QuillEditor
                          value={addEditObject.ExternalDimension}
                          onChange={(value: string) =>
                            setAddEditObject((prev: any) => ({
                              ...prev,
                              ExternalDimension: value,
                            }))
                          }
                        />
                      </div>
                    </div>

                    <div className="field-input grid-d flex-gap3">
                      <span className="font-12 text-left label-color">
                        Use Case:
                      </span>

                      <div className="ck-editor-container">
                        <QuillEditor
                          value={addEditObject.UseCase}
                          onChange={(value: string) =>
                            setAddEditObject((prev: any) => ({
                              ...prev,
                              UseCase: value,
                            }))
                          }
                        />
                      </div>
                    </div>
                    <div className="field-input grid-d flex-gap3">
                      <span className="font-12 text-left label-color">
                        Delivery Info:
                      </span>

                      <div className="ck-editor-container">
                        <QuillEditor
                          value={addEditObject.DeliveryInfo}
                          onChange={(value: string) =>
                            setAddEditObject((prev: any) => ({
                              ...prev,
                              DeliveryInfo: value,
                            }))
                          }
                        />
                      </div>
                    </div>
                  </div>

                  <div className="grid-d fr-111 mt-20 flex-gap20 flex-as">
                    <div className="field-input grid-d flex-gap3">
                      <span className="font-12 text-left label-color">
                        Meta Title:
                      </span>
                      <input
                        className="input-field w-100"
                        value={addEditObject.MetaTitle}
                        onChange={(e) =>
                          setAddEditObject((prevState: any) => ({
                            ...prevState,
                            MetaTitle: e.target.value,
                          }))
                        }
                      />
                    </div>
                    <div className="field-input grid-d flex-gap3">
                      <span className="font-12 text-left label-color">
                        Meta Description:
                      </span>
                      <textarea
                        className="input-field w-100"
                        value={addEditObject.MetaDescription}
                        onChange={(e) =>
                          setAddEditObject((prevState: any) => ({
                            ...prevState,
                            MetaDescription: e.target.value,
                          }))
                        }
                      />
                    </div>
                    <div className="field-input grid-d flex-gap3">
                      <span className="font-12 text-left label-color">
                        Meta Keywords:
                      </span>
                      <textarea
                        className="input-field w-100"
                        value={addEditObject.MetaKeywords}
                        onChange={(e) =>
                          setAddEditObject((prevState: any) => ({
                            ...prevState,
                            MetaKeywords: e.target.value,
                          }))
                        }
                      />
                    </div>
                  </div>
                </>
              )}

              <div className="flex-daj gap-10 mt-20">
                {editMode == 1 && (
                  <div className="flex-daj btn-start">
                    <a
                      className="btn-primary flex-daj"
                      onClick={() => checkValidation(30, 0, "", "")}
                    >
                      Save
                    </a>
                  </div>
                )}
                {editMode == 2 && (
                  <div className="flex-daj btn-start">
                    <a
                      className="btn-primary flex-daj"
                      onClick={() =>
                        checkValidation(30, addEditObject.PTProductID, "", "")
                      }
                    >
                      Update
                    </a>
                  </div>
                )}
                <div className="flex-daj btn-start">
                  <a
                    className="btn-primary flex-daj"
                    onClick={() => setEditMode(0)}
                  >
                    Cancel
                  </a>
                </div>
              </div>
            </>
          )}

          {informationTab == 2 && (
            <>
              <div className="flex-d justify-btw mb-10 mt-20">
                <span></span>
                <div className="flex-daj flex-gap10">
                  {lockedImages == false && (
                    <>
                      <div className="com-toggle">
                        <span className="txt-compare bold-font">
                          Show Order
                        </span>

                        <a
                          className={
                            showOrdersImages ? "com-btn com-sel" : "com-btn"
                          }
                          onClick={() => {
                            setShowOrdersImages(!showOrdersImages);
                          }}
                        >
                          <span></span>
                        </a>
                      </div>

                      <div className="flex-daj btn-start">
                        <a
                          className="btn-primary flex-daj"
                          onClick={() =>
                            updateObjectAdminData(
                              40,
                              addEditObject.PTProductID,
                              "",
                              "addimage",
                            )
                          }
                        >
                          Add New
                        </a>
                      </div>
                    </>
                  )}

                  <LockUnlockV2
                    locked={lockedImages}
                    setLocked={setLockedImages}
                  />
                </div>
              </div>
              <div className="flow-auto">
                <table className="reuse-table" id="tblprodcat">
                  <thead>
                    <tr>
                      <th className="td-md">Name</th>
                      <th className=" sticky-header">
                        <div className="flex-daj flex-gap10">
                          Image Path
                          <a
                            title="Manage Content Library"
                            className="flex-d library-btn"
                            onClick={() => setShowContentLibraryModal(true)}
                          >
                            <img
                              src="images/m-manage.svg"
                              width="18px"
                              height="18px"
                              alt="Edit"
                            />
                          </a>
                        </div>
                      </th>
                      <th className="td-xs">Preview</th>
                      <th className="td-xxs">Ordering</th>
                      <th className="td-xxs">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {imagesData &&
                      imagesData.map((item: any, index: any) => (
                        <React.Fragment key={index}>
                          <tr>
                            <td className="p-all0">
                              <input
                                disabled={lockedImages}
                                value={item.Name}
                                onChange={(e) =>
                                  updateValueImages(
                                    e.target.value,
                                    index,
                                    "Name",
                                  )
                                }
                                onBlur={(e) =>
                                  updateObjectAdminData(
                                    40,
                                    item.PTProductFilesID,
                                    e.target.value,
                                    "Name",
                                  )
                                }
                                className="text-left"
                              />
                            </td>
                            <td className="p-all0">
                              <input
                                disabled={lockedImages}
                                value={item.FilePath}
                                onChange={(e) =>
                                  updateValueImages(
                                    e.target.value,
                                    index,
                                    "FilePath",
                                  )
                                }
                                onBlur={(e) =>
                                  updateObjectAdminData(
                                    40,
                                    item.PTProductFilesID,
                                    e.target.value,
                                    "imgsrc",
                                  )
                                }
                                className="text-left"
                              />
                            </td>
                            <td className="p-all5">
                              {item.FilePath != "" && (
                                <div className="flex-daj">
                                  <div className="contact-attachments m-0">
                                    <div className="remove--image">
                                      <img
                                        src={GetThumbnailImage(item.FilePath)}
                                        alt="img"
                                        width="100"
                                        height="50"
                                        style={{ width: "auto" }}
                                      />
                                    </div>
                                  </div>
                                </div>
                              )}
                            </td>
                            <td className="text-center">
                              <div className="flex-daj flex-gap10">
                                <button
                                  className="no-borbg pointer"
                                  disabled={
                                    index == 0 || lockedImages ? true : false
                                  }
                                  title="Up"
                                  onClick={(e) =>
                                    updateObjectAdminData(
                                      40,
                                      item.PTProductFilesID,
                                      "up",
                                      "PTOrderBy",
                                    )
                                  }
                                >
                                  <img
                                    src="images/o-up.svg"
                                    width="14px"
                                    height="16px"
                                    alt="up"
                                  />
                                </button>
                                <button
                                  className="no-borbg pointer"
                                  disabled={
                                    index == imagesData.length - 1 ||
                                    lockedImages
                                      ? true
                                      : false
                                  }
                                  title="Down"
                                  onClick={(e) =>
                                    updateObjectAdminData(
                                      40,
                                      item.PTProductFilesID,
                                      "down",
                                      "PTOrderBy",
                                    )
                                  }
                                >
                                  <img
                                    src="images/o-down.svg"
                                    width="14px"
                                    height="16px"
                                    alt="down"
                                  />
                                </button>

                                {showOrdersImages && (
                                  <>
                                    <input
                                      className="text-right"
                                      disabled={lockedImages}
                                      value={item.PTOrderBy}
                                      onChange={(e) =>
                                        updateValueImages(
                                          e.target.value,
                                          index,
                                          "PTOrderBy",
                                        )
                                      }
                                      onBlur={(e) =>
                                        updateObjectAdminData(
                                          40,
                                          item.PTProductFilesID,
                                          e.target.value,
                                          "PTOrderBy",
                                        )
                                      }
                                    />
                                  </>
                                )}
                              </div>
                            </td>
                            <td className="text-center">
                              <div className="flex-daj flex-gap10">
                                <button
                                  title="Delete"
                                  className="no-borbg pointer"
                                  disabled={lockedImages}
                                  onClick={() =>
                                    globalState.setConfirmationModalObject({
                                      ShowPopup: true,
                                      Heading: "Alert",
                                      Message:
                                        "Are your sure, you want to delete this record?",
                                      ID: 2,
                                      SelectedID: item.PTProductFilesID,
                                      OtherID: 0,
                                    })
                                  }
                                >
                                  <img
                                    src="images/delete.png"
                                    width="17px"
                                    height="17px"
                                    alt="Edit"
                                  />
                                </button>
                              </div>
                            </td>
                          </tr>
                        </React.Fragment>
                      ))}
                  </tbody>
                </table>
                <div className="flex-daj btn-start mt-20">
                  <a
                    className="btn-primary flex-daj"
                    onClick={() => setEditMode(0)}
                  >
                    Back
                  </a>
                </div>
              </div>
            </>
          )}

          {informationTab == 3 && (
            <>
              <div className="flex-d justify-btw mb-10 mt-20">
                {lockedRelatedProducts == true && <span></span>}
                {lockedRelatedProducts == false && (
                  <div className="flex-da gap-10">
                    <span className="font-mont font-12">Select Product:</span>
                    <div className="field-input">
                      <select
                        className="input-field"
                        value={selectedRelatedProductID}
                        onChange={(e: any) =>
                          setSelectedRelatedProductID(e.target.value)
                        }
                      >
                        <option value="0">Select Product</option>
                        {filterProductList().map((item: any, index: any) => (
                          <React.Fragment key={index}>
                            <option value={item.PID}>{item.Name}</option>
                          </React.Fragment>
                        ))}
                      </select>
                    </div>
                    {selectedRelatedProductID > 0 && (
                      <div className="flex-daj btn-start">
                        <a
                          className="btn-primary flex-daj"
                          onClick={() =>
                            updateObjectAdminData(
                              50,
                              addEditObject.PTProductID,
                              selectedRelatedProductID,
                              "addprod",
                            )
                          }
                        >
                          Add To List
                        </a>
                      </div>
                    )}
                  </div>
                )}

                <div className="flex-daj flex-gap10">
                  {lockedRelatedProducts == false && (
                    <>
                      <div className="com-toggle">
                        <span className="txt-compare bold-font">
                          Show Order
                        </span>

                        <a
                          className={
                            showOrdersRelatedProducts
                              ? "com-btn com-sel"
                              : "com-btn"
                          }
                          onClick={() => {
                            setShowOrdersRelatedProducts(
                              !showOrdersRelatedProducts,
                            );
                          }}
                        >
                          <span></span>
                        </a>
                      </div>
                    </>
                  )}

                  <LockUnlockV2
                    locked={lockedRelatedProducts}
                    setLocked={setLockedRelatedProducts}
                  />
                </div>
              </div>
              <div className="flow-auto">
                <table className="reuse-table" id="tblprodcat">
                  <thead>
                    <tr>
                      <th className="">Name</th>
                      <th className="td-xs">Preview</th>
                      <th className="td-xxs">Ordering</th>
                      <th className="td-xxs">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {relatedProductsData &&
                      relatedProductsData.map((item: any, index: any) => (
                        <React.Fragment key={index}>
                          <tr>
                            <td className="text-left">
                              {item.RelatedProductName}
                              {/* <input
                                disabled={true}
                                value={item.RelatedProductName}
                                // onChange={(e) =>
                                //   updateValueRelatedProduct(
                                //     e.target.value,
                                //     index,
                                //     "Name",
                                //   )
                                // }
                                // onBlur={(e) =>
                                //   updateObjectAdminData(
                                //     50,
                                //     item.PTProductRelatedProductsID,
                                //     e.target.value,
                                //     "Name",
                                //   )
                                // }
                                className="text-left"
                              /> */}
                            </td>
                            <td className="p-all5">
                              {item.RelatedProductThumbnailURL != "" && (
                                <div className="flex-daj">
                                  <div className="contact-attachments m-0">
                                    <div className="remove--image">
                                      <img
                                        src={GetThumbnailImage(
                                          item.RelatedProductThumbnailURL,
                                        )}
                                        alt="img"
                                        width="150"
                                        height="50"
                                        style={{ width: "auto" }}
                                      />
                                    </div>
                                  </div>
                                </div>
                              )}
                            </td>
                            <td className="text-center">
                              <div className="flex-daj flex-gap10">
                                <button
                                  className="no-borbg pointer"
                                  disabled={
                                    index == 0 || lockedRelatedProducts
                                      ? true
                                      : false
                                  }
                                  title="Up"
                                  onClick={(e) =>
                                    updateObjectAdminData(
                                      50,
                                      item.PTProductRelatedProductsID,
                                      "up",
                                      "PTOrderBy",
                                    )
                                  }
                                >
                                  <img
                                    src="images/o-up.svg"
                                    width="14px"
                                    height="16px"
                                    alt="up"
                                  />
                                </button>
                                <button
                                  className="no-borbg pointer"
                                  disabled={
                                    index == relatedProductsData.length - 1 ||
                                    lockedRelatedProducts
                                      ? true
                                      : false
                                  }
                                  title="Down"
                                  onClick={(e) =>
                                    updateObjectAdminData(
                                      50,
                                      item.PTProductRelatedProductsID,
                                      "down",
                                      "PTOrderBy",
                                    )
                                  }
                                >
                                  <img
                                    src="images/o-down.svg"
                                    width="14px"
                                    height="16px"
                                    alt="down"
                                  />
                                </button>

                                {showOrdersRelatedProducts && (
                                  <>
                                    <input
                                      className="text-right"
                                      disabled={lockedRelatedProducts}
                                      value={item.PTOrderBy}
                                      onChange={(e) =>
                                        updateValueRelatedProduct(
                                          e.target.value,
                                          index,
                                          "PTOrderBy",
                                        )
                                      }
                                      onBlur={(e) =>
                                        updateObjectAdminData(
                                          50,
                                          item.PTProductRelatedProductsID,
                                          e.target.value,
                                          "PTOrderBy",
                                        )
                                      }
                                    />
                                  </>
                                )}
                              </div>
                            </td>
                            <td className="text-center">
                              <div className="flex-daj flex-gap10">
                                <button
                                  title="Delete"
                                  className="no-borbg pointer"
                                  disabled={lockedRelatedProducts}
                                  onClick={() =>
                                    globalState.setConfirmationModalObject({
                                      ShowPopup: true,
                                      Heading: "Alert",
                                      Message:
                                        "Are your sure, you want to delete this record?",
                                      ID: 3,
                                      SelectedID:
                                        item.PTProductRelatedProductsID,
                                      OtherID: 0,
                                    })
                                  }
                                >
                                  <img
                                    src="images/delete.png"
                                    width="17px"
                                    height="17px"
                                    alt="Edit"
                                  />
                                </button>
                              </div>
                            </td>
                          </tr>
                        </React.Fragment>
                      ))}
                  </tbody>
                </table>
                <div className="flex-daj btn-start mt-20">
                  <a
                    className="btn-primary flex-daj"
                    onClick={() => setEditMode(0)}
                  >
                    Back
                  </a>
                </div>
              </div>
            </>
          )}

          {informationTab == 4 && (
            <>
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  FAQs Title:
                </span>
                <textarea
                  className="input-field w-100"
                  value={addEditObject.PurchaseNote}
                  onChange={(e) => {
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      PurchaseNote: e.target.value,
                    }));
                  }}
                  onBlur={(e) => {
                    updateObjectAdminData(
                      35,
                      addEditObject.PTProductID,
                      e.target.value,
                      "PurchaseNote",
                    );
                  }}
                />
              </div>

              <ProductFaqs Type={11} PID={addEditObject.PTProductID} />
              <div className="flex-daj btn-start">
                <a
                  className="btn-primary flex-daj"
                  onClick={() => setEditMode(0)}
                >
                  Back
                </a>
              </div>
            </>
          )}

          {informationTab == 5 && (
            <>
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">Schema:</span>
                <textarea
                  className="input-field w-100 schema-notes"
                  value={addEditObject.ObjectSchema}
                  onChange={(e) => {
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      ObjectSchema: e.target.value,
                    }));
                  }}
                />
              </div>
              <div className="flex-daj btn-start gap-10 mt-20">
                <a
                  className="btn-primary flex-daj"
                  onClick={(e) => {
                    updateObjectAdminData(
                      35,
                      addEditObject.PTProductID,
                      addEditObject.ObjectSchema,
                      "ObjectSchema",
                    );
                  }}
                >
                  Update
                </a>
                <a
                  className="btn-primary flex-daj"
                  onClick={() => setEditMode(0)}
                >
                  Back
                </a>
              </div>
            </>
          )}
        </div>
      )}

      {showContentLibraryModal && (
        <div className="popup-help popup-help-index">
          <div className="help-popup-display">
            <div className="help-inner lg-popup-content">
              <div className="help-head flex-da justify-btw">
                <h3 className="m-0 font-16 bold-font">Content Library</h3>
                <a
                  className="close-help"
                  onClick={() => setShowContentLibraryModal(false)}
                >
                  <img
                    src="/images/close.svg"
                    width="15px"
                    height="15px"
                    alt="cross"
                  />
                </a>
              </div>
              <div className="mt-20 p-all0">
                <ContentLibrary />
              </div>
              <div className="flex-daj flex-gap10 mt-20">
                <div className="flex-daj btn-start">
                  <a
                    className="btn-primary flex-daj"
                    onClick={() => setShowContentLibraryModal(false)}
                  >
                    Close
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {showAddNewModal && (
        <div className="popup-help popup-help-index">
          <div className="help-popup-display">
            <div className="help-inner">
              <div className="help-head flex-da justify-btw">
                <h3 className="m-0 font-16 bold-font">Add Product</h3>
                <a
                  className="close-help"
                  onClick={() => setShowAddNewModal(false)}
                >
                  <img
                    src="/images/close.svg"
                    width="15px"
                    height="15px"
                    alt="cross"
                  />
                </a>
              </div>
              <div className="mt-20 p-all0">
                <div className="field-input grid-d flex-gap3">
                  <span className="font-12 text-left label-color">
                    Product Type:
                  </span>
                  <div className="flex-da flex-gap20">
                    <div className="flex-da flex-gap5">
                      <input
                        type="radio"
                        value="0"
                        checked={selectedProductType == 0}
                        onChange={(e: any) =>
                          setSelectedProductType(e.target.value)
                        }
                      />
                      <span className="font-12">Main Product</span>
                    </div>

                    <div className="flex-da flex-gap5">
                      <input
                        type="radio"
                        value="1"
                        checked={selectedProductType == 1}
                        onChange={(e: any) =>
                          setSelectedProductType(e.target.value)
                        }
                      />
                      <span className="font-12">Child Product</span>
                    </div>
                  </div>
                </div>

                {selectedProductType > 0 && (
                  <div className="field-input grid-d flex-gap3 mt-20">
                    <span className="font-12 text-left label-color">
                      Select Parent:
                    </span>
                    <select
                      className="input-field w-100"
                      value={selectedParentID}
                      onChange={(e: any) =>
                        setSelectedParentID(parseInt(e.target.value))
                      }
                    >
                      <option value="0">Select</option>
                      {thisGridListData &&
                        thisGridListData.map((item: any, index: any) => (
                          <React.Fragment key={index}>
                            {item.ParentID == 0 && (
                              <option value={item.PID}>
                                {item.Name} --- ({item.ProductCategory})
                              </option>
                            )}
                          </React.Fragment>
                        ))}
                    </select>
                  </div>
                )}
              </div>
              <div className="flex-daj flex-gap10 mt-20">
                <div className="flex-daj btn-start flex-gap10">
                  <a
                    className="btn-primary flex-daj"
                    onClick={() => addNewRecord()}
                  >
                    Next
                  </a>
                  <a
                    className="btn-primary flex-daj"
                    onClick={() => setShowAddNewModal(false)}
                  >
                    Close
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
export default Product;
